import React, { forwardRef } from 'react'
import IconButton from '@/components/ui/Buttons/IconButton'
import { ReactComponent as ChevronIcon } from '@/assets/icons/chevron-right.svg'
import { IconButtonProps } from '@/components/ui/Buttons/IconButton/IconButton'
import clsx from 'clsx'
import classes from './ToggleButton.module.scss'

export type ToggleButtonProps = IconButtonProps & {
  isOpen?: boolean
}

const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(function CustomToggleButton(
  { isOpen = false, ...props },
  ref
) {
  const className = clsx(classes.root, isOpen && classes.open)

  return (
    <IconButton ref={ref} {...props} isActive={isOpen} className={className}>
      <ChevronIcon />
    </IconButton>
  )
})

export default ToggleButton
